export default __webpack_public_path__ + "static/score-d7fee40130ce844712d5a4c1bb3c154e.png";